import { latestFeed } from "@/mocks/heiliaoHome";

type FeedCard = (typeof latestFeed)[number];

function MetaRow({ card, light }: { card: FeedCard; light?: boolean }) {
  return (
    <div className="flex items-center justify-between gap-2 text-[11px] text-foreground-500 mt-auto pt-3">
      <span className="flex items-center gap-1.5 min-w-0">
        <span className="grid place-items-center h-6 w-6 shrink-0 rounded-full bg-secondary-200 text-secondary-900 text-[10px] font-bold">
          {card.author.slice(0, 1)}
        </span>
        <span className="truncate">{card.author}</span>
        <span className="hidden sm:inline text-foreground-400">· {card.time}</span>
      </span>
      <span className="flex items-center gap-2.5 shrink-0">
        <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{card.comments}</span>
        <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{card.views}</span>
        <span className="flex items-center gap-1 text-primary-500"><i className="ri-heart-3-fill"></i>{card.like}</span>
      </span>
    </div>
  );
}

function WideCard({ card }: { card: FeedCard }) {
  return (
    <a
      href="#"
      onClick={(e) => e.preventDefault()}
      className="lg:col-span-2 group flex flex-col sm:flex-row overflow-hidden rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer"
    >
      <div className="sm:w-2/5 shrink-0 overflow-hidden">
        <img
          src={card.img}
          alt={card.title}
          title={`${card.title} · 1黑料网导航`}
          className="w-full aspect-[16/10] sm:aspect-[4/3] sm:h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
        />
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5 min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <span className={`rounded-md px-2 py-0.5 text-[11px] font-medium ${card.tagClass}`}>{card.tag}</span>
          <span className="text-[11px] text-foreground-400">{card.area}</span>
        </div>
        <h3 className="font-serif text-lg md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
          {card.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{card.excerpt}</p>
        <MetaRow card={card} />
      </div>
    </a>
  );
}

function NormalCard({ card }: { card: FeedCard }) {
  return (
    <a
      href="#"
      onClick={(e) => e.preventDefault()}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer"
    >
      <div className="overflow-hidden">
        <img
          src={card.img}
          alt={card.title}
          title={`${card.title} · 1黑料网入口`}
          className="w-full aspect-[16/10] object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
        />
      </div>
      <div className="flex flex-1 flex-col p-4 min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <span className={`rounded-md px-2 py-0.5 text-[11px] font-medium ${card.tagClass}`}>{card.tag}</span>
          <span className="text-[11px] text-foreground-400">{card.area}</span>
        </div>
        <h3 className="text-[15px] font-semibold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
          {card.title}
        </h3>
        <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600 line-clamp-2 hidden sm:block">{card.excerpt}</p>
        <MetaRow card={card} />
      </div>
    </a>
  );
}

function JoinTile() {
  return (
    <a
      href="#"
      onClick={(e) => e.preventDefault()}
      className="group relative overflow-hidden rounded-lg bg-primary-500 p-5 flex flex-col justify-between min-h-[220px] cursor-pointer hover:bg-primary-600 transition-colors"
    >
      <div className="pointer-events-none absolute -right-4 -bottom-4 text-[120px] leading-none text-primary-400/40 font-serif select-none">瓜</div>
      <div className="relative">
        <i className="ri-edit-circle-line text-3xl text-background-50"></i>
        <p className="mt-4 font-serif text-xl font-black text-background-50 leading-snug">憋不住了？<br />来开一贴说说你的瓜</p>
      </div>
      <span className="relative inline-flex items-center gap-2 mt-5 text-sm font-semibold text-background-50">
        去 1黑料网 发帖讨论
        <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
      </span>
    </a>
  );
}

export default function FeedWall() {
  const feed = latestFeed.slice(1);
  return (
    <section id="feed" className="w-full bg-background-100/70">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-5 md:mb-7">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="h-4 w-1 rounded-full bg-primary-500"></span>
              <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 uppercase">最新瓜田 · 图文并重</span>
            </div>
            <h2 className="font-serif text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
              刚出锅的料，趁热看
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-full border border-background-300/70 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-time-line text-base"></i> 最新
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-full border border-background-300/70 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-600 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-fire-line text-base"></i> 最热
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 items-stretch">
          {feed.map((card, i) =>
            i === 0 || i === 3 ? <WideCard key={card.title} card={card} /> : <NormalCard key={card.title} card={card} />
          )}
          <JoinTile />
        </div>
      </div>
    </section>
  );
}